<app-notification-inbox [compact]="true" (viewAll)="onVerTodas.emit()" />
